module.exports = __webpack_public_path__ + "img/sinpe.3c2b2914.png";